import type { Address } from "viem"
import type { Config } from "wagmi"

import { equalensMultiVeNftVotes } from "@/domains/on-chain/equalens/equalens-multi-ve-nft-votes"

import type { IVoteOnChainTransport } from "./interfaces"

export type VoteOnChainTransportAddresses = {
  equalens26: Address
}

export class VoteOnChainTransport implements IVoteOnChainTransport {
  constructor(
    private readonly config: Config,
    private readonly chainId: number,
    private readonly addresses: VoteOnChainTransportAddresses,
  ) {}

  async loadLastEpochVotes(
    nftIds: Array<number>,
  ): Promise<Array<{ address: Address; balance: number; votePercent: number }>> {
    if (nftIds.length === 0) {
      return []
    }

    const votes = await equalensMultiVeNftVotes({
      chainId: this.chainId,
      config: this.config,
      equalens26: this.addresses.equalens26,
      nftIds,
    })

    return votes ?? []
  }
}
